export function KiaIcon(props: React.HTMLAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 338.667 79.68"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M196.475 70.537c0 .643.203 1.016.576 1.016.315 0 .576-.169.813-.339L303.416 2.709A10.16 10.16 0 0 1 309.511.88h23.196c3.556 0 5.96 2.37 5.96 5.926v44.293c0 5.35-1.185 8.466-5.926 11.31l-28.14 16.932c-.281.195-.613.339-.948.339s-.677-.271-.677-1.253V26.752c0-.61-.169-1.016-.576-1.016-.297 0-.579.152-.813.339l-77.141 50.118c-1.761 1.185-3.827 1.829-5.926 1.795h-51.134c-3.59 0-5.96-2.37-5.96-5.96V8.196c0-.474-.203-.914-.61-.914-.296 0-.577.155-.813.339l-50.895 30.543c-.508.339-.643.576-.643.813 0 .203.102.406.44.779l36.369 36.335c.474.474.813.847.813 1.253 0 .339-.542.61-1.185.61h-32.848c-2.574 0-4.572-.373-5.96-1.761L84.049 54.182a.896.896 0 0 0-.677-.339c-.239 0-.472.081-.677.203L45.852 76.193c-2.235 1.355-3.759 1.727-5.96 1.727H5.995c-3.623.034-5.994-2.37-5.994-5.926V28.547c0-5.384 1.185-8.466 5.96-11.31L34.271.238a1.37 1.37 0 0 1 .745-.237c.44 0 .677.44.677 1.422V59.6c0 .61.135.88.576.88.3 0 .576-.169.847-.339l95.63-57.534c1.829-1.253 4.064-1.862 6.299-1.761h51.472c3.556 0 5.96 2.37 5.96 5.926l-.034 63.765z"
        fill="#131e29"
      />
    </svg>
  )
}
